<template>
    <article class="content">
        <slot></slot>
    </article>
</template>


